import * as yup from "yup";
import { getValidationSchema } from "../../../../../shared/validations/schema";
export const customizeValidationSchema = (editStatus?: boolean) => {

  let defaultSchema: any = getValidationSchema([
    "email",
    "gender",
    "phone",
    "roleID",
    ...(editStatus ? [] : ["password"]),
  ]);

  let customSchema = yup.object().shape({
    fullName: yup
      .string()
      .strict(true)
      .matches(/^[A-Za-z\s]+$/, "Full name can only contain letters and spaces")
      .min(2, "Name must be more than 2 characters")
      .max(50, "Full name cannot exceed more than 50 characters")
      .required("Full name is a required field"),


  });

  return defaultSchema.concat(customSchema);
};
